import Model from './Model'
import {File, Directory} from "./";
export default class Filesystem extends Model
{
    static async get (filesystemId) {
        const { data } = await Http.get(route('api.v1.filesystems.show', filesystemId))

        return {
            files:data.files.data.map(file => {
                return File.make(file)
            }),
            directories:data.directories.data.map(file => {
                return Directory.make(file)
            }),
        }
    }

    static async search (filesystemId, terms) {
        const { data } = await Http.get(route('api.v1.filesystems.search', filesystemId), {
            params: {
                query: terms
            }
        })

        return {
            files:data.files.data.map(file => {
                return File.make(file)
            }),
            directories:data.directories.data.map(file => {
                return Directory.make(file)
            }),
        }
    }

}
